export default "__VITE_ASSET__Che7lGfr__"